import { Collapse, Switch, Tooltip } from "antd";
import ManageAccess from "components/common/ManageAccess/manageAccess";
import SVGIcon from "components/v2/Images/SVGIcon";
import { get, set } from "lodash";
import React from "react";
import { useOutletContext } from "react-router-dom";

import { ROLE, USER_TYPES } from "../../../constants/phase";

const FeaturePermission = (props) => {
  const { allowedPermission, setAllowedPermission, updateClientSettings, masterPermissionSet, categoryArray } = props;

  const { currentRole, entityType } = useOutletContext();

  const handlePermission = (e, permission) => {
    let data = { ...allowedPermission };
    set(data, `${permission.key}`, e);
    setAllowedPermission(data);
  };

  const { Panel } = Collapse;
  return (
    <>
      <div className="border-block profile-table-container mt-4">
        {categoryArray.map((category) => {
          return (
            <Collapse defaultActiveKey={true} className="collapse-container">
              <Panel showArrow={false} header={category}>
                {masterPermissionSet &&
                  masterPermissionSet.map((permission) =>
                    category === permission?.category ? (
                      <>
                        {permission?.visibleTo.includes(entityType) && (
                          <>
                            <div className="feature-container bottom-border-padding">
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <div className="d-flex flex-column">
                                  <div className="d-flex gap-3">
                                    <label className="form-label">{permission?.label}</label>
                                    <div className="info-icon">
                                      <Tooltip title={permission?.description} placement="right">
                                        <SVGIcon src="components/v2/Cards/moreIcons/tooltipInfo.svg" small={true} />
                                      </Tooltip>
                                    </div>
                                  </div>
                                  {permission?.prerequisites && ROLE.SUPER_ADMIN === currentRole && (
                                    <div className="prerequisites-block">
                                      <small className="d-flex">
                                        <i className="prerequisites">{permission?.prerequisites}</i>
                                      </small>
                                    </div>
                                  )}
                                </div>

                                <div>
                                  <Switch
                                    className="small-switcher"
                                    // defaultChecked={permission.defaultValue}
                                    checked={get(allowedPermission, `${permission.key}`)}
                                    onChange={(e) => {
                                      handlePermission(e, permission);
                                    }}
                                    disabled={
                                      //only superadmin can assign permissions
                                      ROLE.SUPER_ADMIN !== currentRole
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ) : null,
                  )}
              </Panel>
            </Collapse>
          );
        })}
        <ManageAccess value={currentRole === USER_TYPES?.SUPER_ADMIN}>
          <div className="react-foo-container">
            <div className="right-btn-block">
              <button className="btn btn-primary" onClick={() => updateClientSettings("userPermissions")}>
                Update
              </button>
            </div>
          </div>
        </ManageAccess>
      </div>
    </>
  );
};
export default FeaturePermission;
